<!-- eslint-disable -->
<svg
  class="icon"
  [ngStyle]="{
    width: 'var(--icon-width, ' + size() + 'px)',
    height: 'var(--icon-height, ' + size() + 'px)'
  }"
>
  <use [attr.href]="name() | src : 'assets'"></use>
</svg>
